import React from 'react'
import { createUseStyles } from 'react-jss'
import COLORS from '../../../../../../styles/colors'

export default function Details() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.boxContainer}>
        <p className={classes.boxText1}>CAUÇÃO DE ENTRADA ATÉ</p>
        <p className={classes.boxText2}>03 meses</p>
      </div>
      <div className={classes.row}>
        <p className={classes.detailText}>Recibo manual</p>
        <div className={classes.verticalDivider} />
        <p className={classes.detailText}>Até 3 meses de depósito*</p>
      </div>
      <div className={classes.row}>
        <p className={classes.detailText}>Sem boleto</p>
        <div className={classes.verticalDivider} />
        <p className={classes.detailText}>Sem cobertura jurídica</p>
      </div>
      <div className={classes.row}>
        <p className={classes.detailText}>Contrato com assinatura eletrônica gratuita</p>
        <div className={classes.verticalDivider} />
        <p className={classes.detailText}>
          Sem taxas
          <br />
          Sem comissão
          <br />
          Sem surpresas
        </p>
      </div>
      <div className={classes.row}>
        <p className={classes.detailText}>A cobrança é feita pelo dono</p>
        <div className={classes.verticalDivider} />
        <p className={classes.detailText}>
          R$10,00
          <br />
          Pagamento único
        </p>
      </div>
      <a
        className={classes.moreDetailsButton}
        href='https://rebrand.ly/caucao'
        target='_blank'
        rel='noopener noreferrer'
      >
        * Mais detalhes
      </a>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    border: `1px solid ${COLORS.brand.primary}`,
    margin: '24px 0',
    borderRadius: 4,
    padding: 8,
  },
  boxContainer: {
    border: `1px solid ${COLORS.brand.primaryDark}`,
    margin: '10px 0',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    padding: 22,
  },
  boxText1: {
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: `${COLORS.brand.primaryDark} !important`,
    textAlign: 'center',
    flex: 1,
  },
  boxText2: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: `${COLORS.brand.primaryDark} !important`,
    textAlign: 'center',
    flex: 1,
  },
  row: {
    padding: '24px 0',
    margin: '0 14px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${COLORS.greyscale.dark}`,
    position: 'relative',
    justifyContent: 'space-between',
  },
  verticalDivider: {
    width: 1,
    position: 'absolute',
    top: 10,
    bottom: 10,
    left: '50%',
    backgroundColor: COLORS.greyscale.dark,
  },
  detailText: {
    textAlign: 'center',
    flex: 1,
    padding: '0 18px',
  },
  moreDetailsButton: {
    border: `1px solid ${COLORS.brand.primary}`,
    color: COLORS.brand.primary,
    width: '100%',
    padding: '10px 0',
    borderRadius: 4,
    display: 'block',
    textAlign: 'center',
    textDecoration: 'none',
    margin: '24px 0',
  },
})
